import React from 'react';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@mui/material';
import { Download } from '@mui/icons-material';
import useModal from 'hooks/useModal';
import { CompanyModel } from 'models/CompanyModel';
import TransactionsDialog from 'modules/companies/dialogs/TransactionsDialog';
import spinner from 'recoil/atoms/spinner';
import Api from 'utils/api';
import { forceDownload } from 'utils/common';


const useLedgerModals = () => {
    const {t} = useTranslation();
    const {showModal} = useModal();
    const setSpinner = useSetRecoilState(spinner);

    const transactionsDownload = (id: number) => {
        setSpinner(true);
        Api.ledger.transactionsDownload(id)
            .then(forceDownload)
            .then(() => setSpinner(false))
    };

    const openTransactions = (company: CompanyModel) => Api.ledger.transactions(company.id)
        .then(data => showModal(TransactionsDialog,
            {transactions: data.data},
            {
                title: t('transactions_for', {value: company.cleanName}),
                maxWidth: 'lg',
                fullWidth: true,
                action: (
                    <IconButton
                        aria-label="dowload transactions"
                        onClick={() => transactionsDownload(company.id)}
                    >
                        <Download/>
                    </IconButton>
                )
            }));

    return {
        openTransactions,
    };
};

export default useLedgerModals;
